<template>
  <div class="mb-4">
    <label :for="label" class="block text-sm leading-5 font-medium text-gray-700 mb-1"
      >{{ label }} <span v-if="optional" class="text-xs text-gray-700">(optional)</span></label
    >
    <div class="mt-1">
      <input
        :id="label"
        v-model="numberValue"
        autocomplete="off"
        type="number"
        class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md field-sizing-fixed"
        :placeholder="placeholder"
        @input="$emit('update:modelValue', $event.target.value)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ['modelValue', 'label', 'placeholder', 'optional'],
  data() {
    return {
      numberValue: this.modelValue,
    };
  },
  watch: {
    modelValue(newVal) {
      this.numberValue = newVal;
    },
  },
};
</script>
